import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Inicio from "pages/Inicio";
import NotFound from "pages/NotFound";
import BasePage from "pages/BasePage";
import LerNoticia from 'pages/Noticias/lerNoticia';
import PalavraDoPresidente from "pages/PalavraDoPresidente";
import { trackPageView } from './analytcs';
import EventosAnteriores from 'pages/EventosAnteriores';
import Programacao from 'pages/Programacao/';
import Contato from 'pages/Contato';
// import Galeria from 'pages/Galeria';
import OrganizerDetail from 'components/PalavraOrganizadores/OrganizerDetail';
import ScrollToTop from 'components/ScrolltoTop';
import Noticias from 'pages/Noticias';
import DicasEServicos from 'pages/Dicas&servicos'

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
};

function AppRoutes() {
  return (
    <BrowserRouter>
				<ScrollToTop />
      <Analytics />
      <Routes>
        <Route path="/" element={<BasePage />}>
          <Route index element={<Inicio />}></Route>
          <Route path="*" element={<NotFound />}></Route>
          <Route path="/noticia/:noticiaId" element={<LerNoticia />} />
          <Route path="/palavra-do-presidente" element={<PalavraDoPresidente />}></Route>
					<Route path="/eventos-anteriores" element={<EventosAnteriores />}></Route>
					<Route path="/programacao" element={<Programacao />}></Route>
          <Route path='/dicas' element={<DicasEServicos/>}></Route>
					<Route path="/contato" element={<Contato />}></Route>
          {/* <Route path="/galeria" element={<Galeria />} ></Route>  */}
					<Route path="noticias" element={<Noticias/>}></Route>
					<Route path="/organizador/:name" element={<OrganizerDetail />} ></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;
